export default __webpack_public_path__ + "static/media/1991.80b279d5.png";